import { Component } from '@angular/core';

@Component({
  selector: 'app-cards8-examples-50',
  templateUrl: './cards8-examples-50.component.html'
})
export class Cards8Examples50Component {}
